<template>
  <div class="tree_warp">
    <div class="selectOnints" v-if="roletype == 0">
      <span>{{dataobjsSend.zhankaijibie}}:</span>
      <el-select v-model="valueinsts" placeholder="请选择" style="width:140px" @change="mycityHande">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </div>
    <el-input
      :placeholder="dataobjsSend.qingshuruneirong"
      v-if="!treeHidder"
      v-model="search"
      class="input-with-select"
    >
      <el-button slot="append" icon="el-icon-search" @click="serchBten"></el-button>
    </el-input>
    <div class="tree_in">
      <!--  show-checkbox -->
      <el-tree
        ref="tree"
        :highlight-current="true"
        :data="treedata"
        :props="defaultProps"
        node-key="uuid"
        :default-expanded-keys="keystree"
        :default-checked-keys="keystree"
        :filter-node-method="filterNode"
        :default-expand-all="isExpand"
        @node-click="handleNodeClick"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>
            <!-- <i :class="data.class"> -->
            <span>{{data.lable}}</span>
            <!-- </i> -->
          </span>
        </span>
      </el-tree>

      <!-- <el-tree
  :data="data"
  node-key="id"
  :default-expanded-keys="[2]"
  :default-checked-keys="[5]"
  :props="defaultProps">
      </el-tree>-->
    </div>
    {{keystreeList}}
  </div>
</template>
<script>
export default {
  props: {
    treedata: {
      type: Array,
      default: [],
    },
    keystree: {
      type: Array,
      default: [],
    },
    treeHidder: {
      type: Boolean,
      default: true,
    },
    dataobjsSend: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      search: "",
      data: [],
      defaultProps: {
        children: "child",
        label: "lable",
      },
      options: [
        {
          value: "province",
          label: "省",
        },
        {
          value: "city",
          label: "市",
        },
        {
          value: "county",
          label: "区/县",
        },
        {
          value: "dealer_uuid",
          label: "经销商",
        },
        {
          value: "customer_uuid",
          label: "客户",
        },
      ],
      valueinsts: "",
      isExpand: false,
      cityCint: false, //市
      roletype: sessionStorage.getItem("roletypeValue"),
    };
  },
  computed: {
    // 默认打开当前打开的树
    keystreeList() {
      if (this.keystree[0] != undefined) {
        let keys = this.keystree[0];
        // console.log(this.keystree);

        setTimeout(() => {
          this.$refs.tree.setCurrentKey(keys);
        }, 1000);

        // });
      }
    },
  },
  mounted() {},
  methods: {
    serchBten() {
      this.$refs.tree.filter(this.search);
    },
    // 树形控件搜索
    filterNode(value, data, node) {
      if (!value) {
        return true;
      }
      let level = node.level;
      let _array = []; //这里使用数组存储 只是为了存储值。
      this.getReturnNode(node, _array, value);
      let result = false;
      _array.forEach((item) => {
        result = result || item;
      });
      return result;
    },
    //树形控件搜索
    getReturnNode(node, _array, value) {
      let isPass =
        node.data && node.data.lable && node.data.lable.indexOf(value) !== -1;
      isPass ? _array.push(isPass) : "";
      this.index++;
      // console.log(this.index);
      if (!isPass && node.level != 1 && node.parent) {
        this.getReturnNode(node.parent, _array, value);
      }
    },
    handleNodeClick(e) {
      this.$emit('chuindScllor')
      // this.$emit('listTree',e)
      if (e.customer_uuid != undefined) {
        // console.log(e.gateway_uuid);
        this.$emit("trreList", e.customer_uuid);
      }
    },
    //展示省市区经销商客户
    mycityHande(e) {
      switch (e) {
        case "province": //省
          // 全部折叠
          for (
            let i = 0;
            i < this.$refs.tree.store._getAllNodes().length;
            i++
          ) {
            this.$refs.tree.store._getAllNodes()[i].expanded = false;
          }

          break;

        case "city": //市
          let cityArr = [];

          // 折叠区域
          this.treedata.forEach((item, index) => {
            item.child.forEach((item1, index1) => {
              //折叠上
              this.$refs.tree.store.nodesMap[item1.uuid].expanded = false;
            });
          });

          this.treedata.forEach((item, index) => {
            //展开
            cityArr.push(item.uuid);
          });

          this.$emit("countClickTree", cityArr);
          break;

        case "county": //区县
          let countyArr = [];
          this.cityCint = true; //折叠

          this.treedata.forEach((item) => {
            item.child.forEach((item1) => {
              //  console.log(this.$refs.tree.store.nodesMap[item1.uuid].expanded = true);
              countyArr.push(item1.uuid);
            });
          });
          //  this.keystree = countyArr;
          this.$emit("countClickTree", countyArr);
          /**折叠经销商 */
          this.treedata.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                this.$refs.tree.store.nodesMap[item2.uuid].expanded = false;
              });
            });
          });

          break;
        case "dealer_uuid": //经销商
          let dealer_uuids = [];
          this.treedata.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                dealer_uuids.push(item2.uuid);
              });
            });
          });
          this.$emit("countClickTree", dealer_uuids);

          // 关闭客户
          this.treedata.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                item2.child.forEach((item3) => {
                  // console.log(item3);
                  this.$refs.tree.store.nodesMap[item3.uuid].expanded = false;
                });
              });
            });
          });
          break;

        case "customer_uuid": //客户
          let customer_uuids = [];
          this.treedata.forEach((item) => {
            item.child.forEach((item1) => {
              item1.child.forEach((item2) => {
                item2.child.forEach((item3) => {
                  // console.log(item3);
                  customer_uuids.push(item3.uuid);
                });
              });
            });
          });
          this.$emit("countClickTree", customer_uuids);
          break;
      }
    },
  },
};
</script>
<style scoped>
.selectOnints {
  display: flex;
  align-items: center;
  padding: 3px 0;
}
.tree_in {
  height: 200px;
  /* overflow: auto; */
  /* width: 240px; */
}
.el-icon-s-custom {
  color: rgb(24, 199, 252);
}
.el-icon-s-help {
  color: rgb(255, 166, 102);
}
.el-icon-map-location {
  color: rgb(255, 181, 77);
}
.el-icon-s-custom span,
.el-icon-s-help span,
.el-icon-map-location span {
  color: #606266;
}

.s-bg2 {
  background: #eee;
}
.s-c {
  color: bule;
}
</style>